var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSportActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#6A8860"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#6A8860"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2116 17.4201C26.6956 17.4201 26.2156 17.2281 25.8436 16.8681L19.6036 10.9521C18.7996 10.1841 17.6356 9.89606 16.5556 10.1961L13.4716 11.0481L13.9756 12.8481L17.0596 11.9961C17.5036 11.8761 17.9836 11.9961 18.3196 12.3081L19.6996 13.6161L17.2876 15.4881C16.6276 15.9921 16.2196 16.7721 16.1836 17.6001C16.1356 18.4281 16.4476 19.2441 17.0476 19.8201C17.0476 19.8201 19.0036 21.7281 20.0236 22.7121L13.0156 25.5441L13.7116 27.2721L19.7116 24.8481L18.0556 30.5241L19.8436 31.0521L22.0036 23.6841C22.1116 23.5281 22.1836 23.3601 22.2316 23.1681C22.3396 22.6881 22.1836 22.1961 21.8236 21.8481C21.5596 21.5961 20.8516 20.9121 20.1436 20.2161L23.5996 17.3001L24.5836 18.2241C25.3036 18.9081 26.2396 19.2801 27.2356 19.2801H30.9676V17.4201H27.2116ZM18.7756 18.9081C18.5116 18.6441 18.3436 18.4881 18.3436 18.4761C18.1276 18.2721 18.0196 17.9961 18.0436 17.6961C18.0556 17.3961 18.1996 17.1321 18.4276 16.9521L21.0676 14.9121L22.2076 16.0041L18.7756 18.9081Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0994 14.1681C26.5394 14.1681 27.7154 12.9921 27.7154 11.5521C27.7154 10.1121 26.5394 8.9361 25.0994 8.9361C23.6594 8.9361 22.4834 10.1121 22.4834 11.5521C22.4834 12.9921 23.6594 14.1681 25.0994 14.1681ZM25.0994 10.8201C25.5074 10.8201 25.8434 11.1561 25.8434 11.5641C25.8434 11.9721 25.5074 12.3081 25.0994 12.3081C24.6914 12.3081 24.3554 11.9721 24.3554 11.5641C24.3554 11.1561 24.6914 10.8201 25.0994 10.8201Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4997 14.6241H9.05566V16.2441H15.4997V14.6241Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4993 17.2761H11.2393V18.8961H15.4993V17.2761Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4998 19.868H13.3398V21.488H15.4998V19.868Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportActive);
export default __webpack_public_path__ + "static/media/sportActive.a8eaf2bbc23828866136cee8d2d00e5d.svg";
export { ForwardRef as ReactComponent };